module.exports = __webpack_public_path__ + "img/生活日語.2644b3a9.png";